import React from 'react'

function Logout() {
  return (
    <div>
     logout 
    </div>
  )
}

export default Logout
